import { render } from "./MultiInstances.vue?vue&type=template&id=68f57612&scoped=true"
import script from "./MultiInstances.vue?vue&type=script&lang=js"
export * from "./MultiInstances.vue?vue&type=script&lang=js"

import "./MultiInstances.vue?vue&type=style&index=0&id=68f57612&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f57612"]])

export default __exports__